var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup836(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7887 51.2428L25.4683 41.0142L34.465 50.5212L52.8285 31.1227C58.1022 36.6957 58.0597 45.6856 53.1476 51.2563L34.6522 70.8009L15.7866 51.2406L15.7887 51.2428Z",
    fill: "#5B836D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1869 7.14251C54.8177 -0.644758 43.4788 -2.23189 34.4629 3.20841C25.4471 -2.23189 14.1082 -0.642511 6.74112 7.14251C-2.24704 16.6383 -2.24704 32.0937 6.74112 41.5917L13.2637 48.4842L22.8943 38.3073L16.3717 31.417C12.6935 27.5301 12.6935 21.2086 16.3717 17.3217C19.4309 14.089 24.1601 13.4685 27.8745 15.811L34.4651 20.9748L41.0557 15.811C44.7701 13.4685 49.4992 14.0912 52.5584 17.3217C55.2112 20.125 55.9345 24.1873 54.7581 27.6942C58.1342 30.9831 60.251 35.6928 60.251 40.9285C60.251 41.9469 60.1659 42.9428 60.0127 43.914L62.189 41.594C71.175 32.0959 71.175 16.6428 62.189 7.14475",
    fill: "#5B836D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup836);
export default __webpack_public_path__ + "static/media/Group836.80187012b05de1538af151c5b6604838.svg";
export { ForwardRef as ReactComponent };